import { createGuid, isGuid, getMeta, getDynData } from "../../scripts/general_functions";
import { getImageByContentId } from "../../scripts/images";
import { getLangForApi } from "#scripts/cmsapi.js";
//import { checkNested, getConfig, createGuid, getMeta, getDynData, testDynData, getDynDataOne } from "./general_functions";
import language from "../../scripts/translation";
import cardslist from "./cardlisting_template";
import { carditem } from "./cardlisting_template";

export const getItems = (category, load = 3, from = 0, callback) => {
  const data = {
    categoryId: "e91af1d7-519b-475e-a338-fbd00746f954",
    subscriptionId: client.clientId,
  };

  if (isGuid(category)) {
    data.categoryId = category;
  } else {
    // data.categoryId = '94a628d6-30d1-4df5-95a6-8ee950941efe';//getCategoryFromString(category);
    data.categoryId = getCategoryFromString(category);
  }

  const defaultContentTypes = [
    "5be9ba0d-3682-4493-9587-306a99911bf3", // mal_artikkel
    "93847071-c959-4ce5-a79a-686af7dbd419", // mal_enhet
    "8ee596e3-98cc-43e0-b785-96cc6325773c", // Artikkel m/bilde
    "4e159a34-1e45-413f-b053-a2bd9f843121", // Forsidekampanje
    "1bb71f41-4ee6-4394-b78f-3202e2f5eeda", // Transportside
    "e662f30f-ecd9-4974-8657-35b726365572", // Temaside
    "fd54728e-1956-433b-a33b-a7f95023dd37", // Fokusartikkel
    "453b9f75-ff2f-41cb-8504-04572637d756", // ExternalNavLink
    "a72e7e73-1864-46ee-adba-814d05b51d9e", // Prosjekt
  ];

  // fetch(window.apiUrl + "/api/PublicContentApi/getbycategoryidasstring", {
  fetch(`${window.apiUrl}/api/Public/articles?subscriptionId=${client.clientId}&category=${category}&language=${getLangForApi()}&contentTypes=${defaultContentTypes.join(",")}&IncludeCategories=true&limit=${load}&getRecursiveContent=true&sortBy=Title&LanguageMode=Strict`, {
    method: "GET",
    // method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    // body: JSON.stringify(data),
  })
    .then((results) => results.json())
    .then((data) => {
      // callback(data);
      callback(data.listOfContent);
    });
};

export const getCategoryFromString = async (category) => {
  const response = await fetch(window.apiUrl + "/api/CategoryApi/getbytitle/" + category);
  const json = await results.json();

  if (json.length > 0) {
    json.forEach((cat) => {
      if (cat.subscriptionId == client.clientId) {
        return cat.categoryId;
      }
    });
  }
};

export const cardsFront = (category, maxItems = 3, moduleTitle, moreText = "Se mer", moreLink = "", cardDesign = "", showCategories = true) => {
  const categoryId = category;
  let moduleGuid = createGuid();
  getItems(category, 100, 0, (data) => {
    let cards = [];
    let cardCount = 0;

    if (data.length > 0) {
      data.forEach((card) => {
        let meta = getMeta(card);
        let details = getDynData(meta);
        let cardGuid = createGuid();
        let isTransportPage = card.contentTypeGuid === "1bb71f41-4ee6-4394-b78f-3202e2f5eeda";

        // we can't relay on the order of the categories anymore, so we need to check if nameInUrl=currentPathname
        // let shouldShow = isTransportPage ? showCategories && !document.location.pathname.toLowerCase().includes(card.nameInUrl.toLowerCase()) : true;
        let shouldShow = isTransportPage ? showCategories && card.categories[0].categoryId !== categoryId : true;

        if (card.title && shouldShow && !card.isVisibleInNavigation === false) {
          let image = ``;
          let hasImage = false;
          let cloudinaryUrl = "";

          if (meta.imageContentId) {
            hasImage = true;
            image = `<div class="card__image_container"><img src='/images/transparent.png' id='card__${cardGuid}' class="card__image" desc="${meta.imageDescription}" alt="${meta.imageDescription}"></div>`;
            getImageByContentId(meta.imageContentId, (img) => {
              if ($(document).width() <= 770) {
                //Mobile view
                cloudinaryUrl = "https://res.cloudinary.com/ssp/image/fetch/g_center,w_770,h_433,c_fill/" + img.url;
              } else {
                //Desktop view
                if (maxItems == 1) {
                  cloudinaryUrl = "https://res.cloudinary.com/ssp/image/fetch/g_center,w_180,h_180,c_fill/" + img.url;
                } else {
                  cloudinaryUrl = "https://res.cloudinary.com/ssp/image/fetch/g_center,w_360,h_200,c_fill/" + img.url;
                }
              }
              $(`#card__${cardGuid}`).attr("src", cloudinaryUrl);
            });
          }

          let link = `/artikkel/${card.nameInUrl}`;
          let linktext = "Les mer her";
          let dynLink = getDynData(meta, "dddc6cac-9579-4d59-9f52-c3a85ca05473").res;

          if (dynLink) {
            link = dynLink;
            // `<span class="card__link">Gå til siden</span>`;
            // linktext = language("CARD_GOTOPAGE");
          }

          cardCount++;
          cards.push({
            item: carditem({
              link: link,
              image: image,
              title: card.title,
              // intro: card.intro
            }),
            order: card.modified,
          });
        }
      });
    }

    let sortedCards = cards.sort((a, b) => {
      if (a.order < b.order) return 1;
      if (a.order > b.order) return -1;
      return 0;
    });

    sortedCards = sortedCards.slice(0, maxItems);

    if (sortedCards.length < 1) {
      $("#cards_" + moduleGuid + ">div").html("");
    } else {
      let joinedCards = sortedCards.map((e) => e.item).join("");
      $("#cards_" + moduleGuid).html(joinedCards);
      if (cards.length < data.length) {
        // $("#cards").append(`<div class="justify-content-center-"><a class="simple-button-plugin" href="/nav/prosjekter" target="_blank">${language("NEWS_SEEALL")}</a></p>`);
      }
    }
  });

  return cardslist({
    id: moduleGuid,
    title: moduleTitle != undefined ? moduleTitle : ``,
    moretitle: language("CARDS_SEEALL") != "CARDS_SEEALL" ? language("CARDS_SEEALL") : moreText != "" ? moreText : "Se mere...",
    morelink: moreLink != "" ? moreLink : "/nav/" + category,
    cardDesign: cardDesign,
  });
};
